// The support mailbox, for the pages a signed-out person reads (FXACCESS PM-40:
// Login and Welcome gave no address, so a lost invitation or a lost phone left
// the product). Baked at build from VITE_SUPPORT_EMAIL, which the Dockerfile
// sets to `support_email` from infra/terraform.tfvars (a test holds them equal).
// With none configured (dev, tests) the words say the thing that is always true:
// the invitation's Reply-To is the support mailbox.

const configured = (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() || null;

export const SUPPORT_EMAIL: string | null = configured;

/** "email support@… from the address it was sent to" or "reply to your invitation email". */
export function contactPhrase(from = 'the address your invitation was sent to'): string {
  return SUPPORT_EMAIL ? `email ${SUPPORT_EMAIL} from ${from}` : 'reply to your invitation email';
}

export const SIGNED_OUT_WORDS = {
  lostInvitation: () =>
    `Lost your invitation, or has it expired? ${capitalise(contactPhrase())} and we’ll send a new one.`,
  firstTime: 'First time here? See how the first sign-in works',
} as const;

function capitalise(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
